var _g, _rect, _circle, _circle2, _path, _path2, _path3, _path4, _g2, _g3, _g4, _g5, _path5, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _rect2, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectiveDailyFlossing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 149,
    viewBox: "0 0 257 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11322_9776)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137.263,
    y: 67.7637,
    width: 40.9231,
    height: 40.9231,
    rx: 2.84615,
    transform: "rotate(9.35937 137.263 67.7637)",
    fill: "#2392F8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.125,
    cy: 91.2812,
    r: 15.0769,
    transform: "rotate(9.35937 154.125 91.2812)",
    stroke: "white",
    strokeWidth: 1.07692,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.125,
    cy: 91.2808,
    r: 6.46154,
    transform: "rotate(9.35937 154.125 91.2808)",
    stroke: "white",
    strokeWidth: 1.07692,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.415 61.3659C151.463 61.0725 151.265 60.7954 150.971 60.747C150.678 60.6987 150.401 60.8973 150.352 61.1908L151.415 61.3659ZM154.521 65.6979C152.467 65.3594 151.077 63.4199 151.415 61.3659L150.352 61.1908C149.917 63.8316 151.705 66.3252 154.346 66.7605L154.521 65.6979Z",
    fill: "#2392F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.342 70.1691L154.434 66.2285",
    stroke: "#2392F8",
    strokeWidth: 1.07692
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.765 79.7322L157.107 76.4922",
    stroke: "white",
    strokeWidth: 1.07692
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.766 79.7324L178.36 79.9951C181 80.4304 183.494 78.6424 183.929 76.0016V76.0016C184.365 73.3608 182.577 70.8671 179.936 70.4318L178.342 70.1691",
    stroke: "#2392F8",
    strokeWidth: 1.07692
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 78.4941,
    y: 19.2988,
    width: 46.7692,
    height: 46.7692,
    rx: 3.25275,
    transform: "rotate(-7.27315 78.4941 19.2988)",
    fill: "#2392F8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 104.65,
    cy: 39.5347,
    r: 17.2308,
    transform: "rotate(-7.27315 104.65 39.5347)",
    stroke: "white",
    strokeWidth: 1.23077,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.651,
    cy: 39.5339,
    r: 7.38462,
    transform: "rotate(-7.27315 104.651 39.5339)",
    stroke: "white",
    strokeWidth: 1.23077,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.8975 7.66135C91.8545 7.32422 91.5463 7.0858 91.2092 7.12882C90.8721 7.17185 90.6336 7.48003 90.6767 7.81717L91.8975 7.66135ZM96.7159 11.389C94.356 11.6902 92.1987 10.0213 91.8975 7.66135L90.6767 7.81717C91.0639 10.8514 93.8375 12.9971 96.8717 12.6099L96.7159 11.389Z",
    fill: "#2392F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.263 8.49416L96.7939 12",
    stroke: "#2392F8",
    strokeWidth: 1.23077
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.666 19.4817L103.08 22.3643",
    stroke: "white",
    strokeWidth: 1.23077
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.666 19.4814L127.497 19.2477C130.532 18.8605 132.677 16.0869 132.29 13.0527V13.0527C131.903 10.0185 129.129 7.87268 126.095 8.25993L124.264 8.49365",
    stroke: "#2392F8",
    strokeWidth: 1.23077
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11322_9776)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82.2461,
    y: 76.3477,
    width: 40.9231,
    height: 40.9231,
    rx: 2.84615,
    transform: "rotate(6.97018 82.2461 76.3477)",
    fill: "#2392F8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.073,
    cy: 99.1408,
    r: 15.0769,
    transform: "rotate(6.97018 100.073 99.1408)",
    stroke: "white",
    strokeWidth: 1.07692,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.073,
    cy: 99.1413,
    r: 6.46154,
    transform: "rotate(6.97018 100.073 99.1413)",
    stroke: "white",
    strokeWidth: 1.07692,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1185 69.3642C96.1546 69.069 95.9445 68.8004 95.6493 68.7643C95.3541 68.7283 95.0856 68.9383 95.0495 69.2335L96.1185 69.3642ZM99.4024 73.563C97.3361 73.3103 95.8658 71.4305 96.1185 69.3642L95.0495 69.2335C94.7247 71.8902 96.6151 74.3071 99.2717 74.6319L99.4024 73.563Z",
    fill: "#2392F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.39 77.0381L99.3379 74.0977",
    stroke: "#2392F8",
    strokeWidth: 1.07692
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.213 86.6589L102.438 84.2412",
    stroke: "white",
    strokeWidth: 1.07692
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.213 86.6592L123.816 86.8552C126.473 87.18 128.89 85.2896 129.215 82.633V82.633C129.54 79.9763 127.649 77.5593 124.993 77.2345L123.389 77.0385",
    stroke: "#2392F8",
    strokeWidth: 1.07692
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_11322_9776)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 183.991,
    y: 27.7998,
    width: 35.0769,
    height: 35.0769,
    rx: 2.43956,
    transform: "rotate(21.8386 183.991 27.7998)",
    fill: "#2392F8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.747,
    cy: 50.6047,
    r: 12.9231,
    transform: "rotate(21.8386 193.747 50.6047)",
    stroke: "white",
    strokeWidth: 0.923077,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.747,
    cy: 50.6046,
    r: 5.53846,
    transform: "rotate(21.8386 193.747 50.6046)",
    stroke: "white",
    strokeWidth: 0.923077,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.02 25.0662C197.115 24.8296 197 24.5609 196.763 24.4661C196.527 24.3713 196.258 24.4862 196.163 24.7228L197.02 25.0662ZM198.817 29.267C197.161 28.6032 196.356 26.7225 197.02 25.0662L196.163 24.7228C195.31 26.8523 196.344 29.2704 198.474 30.1238L198.817 29.267Z",
    fill: "#2392F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.924 37.4213L198.646 29.6953",
    stroke: "#2392F8",
    strokeWidth: 0.923077
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.834 45.1328L198.982 38.7803",
    stroke: "white",
    strokeWidth: 0.923077
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.834 45.1328L216.119 45.6479C218.249 46.5013 220.667 45.4668 221.52 43.3373V43.3373C222.374 41.2079 221.339 38.7898 219.21 37.9364L217.924 37.4213",
    stroke: "#2392F8",
    strokeWidth: 0.923077
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_11322_9776)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.5137,
    y: 50.5205,
    width: 35.0769,
    height: 35.0769,
    rx: 2.43956,
    transform: "rotate(-17.6336 38.5137 50.5205)",
    fill: "#2392F8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5412,
    cy: 61.9216,
    r: 12.9231,
    transform: "rotate(-17.6336 60.5412 61.9216)",
    stroke: "white",
    strokeWidth: 0.923077,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5419,
    cy: 61.9218,
    r: 5.53846,
    transform: "rotate(-17.6336 60.5419 61.9218)",
    stroke: "white",
    strokeWidth: 0.923077,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8344 40.1268C46.7572 39.8839 46.4976 39.7495 46.2547 39.8267C46.0118 39.904 45.8775 40.1635 45.9547 40.4064L46.8344 40.1268ZM50.892 42.2271C49.1916 42.7676 47.3749 41.8273 46.8344 40.1268L45.9547 40.4064C46.6496 42.5927 48.9854 43.8017 51.1717 43.1068L50.892 42.2271Z",
    fill: "#2392F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8246 36.3764L51.0312 42.668",
    stroke: "#2392F8",
    strokeWidth: 0.923077
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3409 44.2927L57.0664 49.4658",
    stroke: "white",
    strokeWidth: 0.923077
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3418 44.293L74.6614 43.8735C76.8477 43.1786 78.0567 40.8429 77.3617 38.6565V38.6565C76.6668 36.4702 74.331 35.2612 72.1447 35.9562L70.8252 36.3756",
    stroke: "#2392F8",
    strokeWidth: 0.923077
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_11322_9776)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139.988,
    y: 16.0557,
    width: 35.0769,
    height: 35.0769,
    rx: 2.43956,
    transform: "rotate(8.99667 139.988 16.0557)",
    fill: "#2392F8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.568,
    cy: 36.1209,
    r: 12.9231,
    transform: "rotate(8.99667 154.568 36.1209)",
    stroke: "white",
    strokeWidth: 0.923077,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.569,
    cy: 36.1206,
    r: 5.53846,
    transform: "rotate(8.99667 154.569 36.1206)",
    stroke: "white",
    strokeWidth: 0.923077,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.084 10.494C152.124 10.2423 151.952 10.0059 151.7 9.96601C151.448 9.92615 151.212 10.0979 151.172 10.3497L152.084 10.494ZM154.77 14.1903C153.007 13.9113 151.805 12.2564 152.084 10.494L151.172 10.3497C150.813 12.6156 152.359 14.7433 154.625 15.102L154.77 14.1903Z",
    fill: "#2392F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.211 17.8943L154.697 14.6465",
    stroke: "#2392F8",
    strokeWidth: 0.923077
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.912 26.0991L157.045 23.4287",
    stroke: "white",
    strokeWidth: 0.923077
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.912 26.0996L175.28 26.3161C177.546 26.6749 179.673 25.1288 180.032 22.863V22.863C180.391 20.5971 178.845 18.4694 176.579 18.1106L175.211 17.8941",
    stroke: "#2392F8",
    strokeWidth: 0.923077
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 91C52 89.8954 52.8954 89 54 89H74.2654C75.2607 89 76.1046 89.7319 76.2453 90.7172L79.7547 115.283C79.8954 116.268 80.7393 117 81.7346 117H182.265C183.261 117 184.105 116.268 184.245 115.283L187.755 90.7172C187.895 89.7319 188.739 89 189.735 89H210C211.105 89 212 89.8954 212 91V117V143C212 144.105 211.105 145 210 145H180H84H54C52.8954 145 52 144.105 52 143V117V91Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 123.5,
    r: 1.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 43.5,
    r: 1.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 255.5,
    cy: 56.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 6.5,
    r: 1.5,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 238.5,
    cy: 118.5,
    r: 1.5,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 187.5,
    cy: 3.5,
    r: 1.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.04,
    width: 216,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 24 149)",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 9L50.5 17.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 91L25.5 87.5M220 20.5L234 13.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M223.5 77.5L241.5 82.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11322_9776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(132.107 56) rotate(9.35937)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11322_9776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(76.6045 64.8086) rotate(6.97018)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_11322_9776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(181.855 17) rotate(21.8386)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_11322_9776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(30 43.541) rotate(-17.6336)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_11322_9776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(135.506 6) rotate(8.99667)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectiveDailyFlossing);
export default __webpack_public_path__ + "static/media/collective-daily-flossing.0fd22bc5619b0f1dd6e61261e70bbe82.svg";
export { ForwardRef as ReactComponent };